export enum PromptTag {
  System = 'system',
  Summary = 'summary',
  Answer = 'answer',
  QueryTransform = 'query-transform',
  Eval = 'eval',
}

export interface Prompt {
  id?: string;
  created_at?: string;
  updated_at?: string;
  name: string;
  description: string;
  content: string;
  tag?: PromptTag;
  top_k?: number;
  top_p?: number;
  temperature?: number;
  tuneable: boolean;
  max_output_tokens?: number;
  thinking_budget?: number;
}
